// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15RUU","tabsBox":"styles_tabsBox__2IT8y","createButton":"styles_createButton__3ln4d"};